import { useEffect, useRef, useState } from "react";
import { Send, Mic } from "lucide-react";
import { Typography } from "antd";
import "./bot.css"; // 👈 we’ll define the animation here
import superuserService from "@/services/superadminService";
const { Text } = Typography;


function groupByGroupName(charts) {
    const grouped = charts.reduce((acc, chart) => {
        const groupName = chart.group?.group_name;
        if (groupName) {
            if (!acc[groupName]) {
                acc[groupName] = [];
            }
            acc[groupName].push(chart);
        }
        return acc;
    }, {});

    const allCharts = Object.values(grouped).flat();

    const groupedWithAllReportsFirst = {
        "All Reports": allCharts,
        ...grouped
    };

    return groupedWithAllReportsFirst;
}


function ChatInput({ input, setInput, sendMessage, loading }) {
    const [listening, setListening] = useState(false);
    const recognitionRef = useRef(null);
    const [chartTitles, setChartTitle] = useState({});
    const [recommendations, setRecommendations] = useState([{ id: 1, title: "Chart List" }])

    const fetchChartData = async () => {
        try {
            const chartItems = [];

            const dailychartinfo = await superuserService.getownersCharts('DAILY');
            const monthlychartinfo = await superuserService.getownersCharts('MONTHLY');

            const nonGeneralCharts = dailychartinfo?.data?.filter(
                (x) => x?.variant !== "GENERAL"
            );
            const monthlynonGeneralCharts = monthlychartinfo?.data?.filter(
                (x) => x?.variant !== "GENERAL"
            );
            console.log("monthlynonGeneralCharts", monthlynonGeneralCharts)
            const dailyTitles =
                nonGeneralCharts?.map((x) => {
                    return { topic: x?.topic, title: x?.chart_title }
                }
                )?.filter(Boolean);
            const monthlyTitles =
                monthlynonGeneralCharts?.map((x) => {
                    return { topic: x?.topic, title: x?.chart_title }
                }
                )

            // Build final object
            const chartTitles = {
                DAILY: [...new Set(dailyTitles)],
                MONTHLY: [...new Set(monthlyTitles)]
            };


            Object.entries(chartTitles).forEach(([period, charts]) => {
                charts.forEach((chart, index) => {
                    const { topic, title } = chart;

                    chartItems.push({
                        id: `chart-${period}-${title}-${index}`,
                        title: title,

                    });
                });
            });
            setRecommendations(chartItems)
            console.log("chartItems", chartItems)
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchChartData();

    }, []);

    console.log("chartTitles", chartTitles)

    // 🎙️ Speech recognition setup
    const initRecognition = () => {
        const SpeechRecognition =
            window.SpeechRecognition || window.webkitSpeechRecognition;

        if (!SpeechRecognition) {
            alert("Speech recognition not supported in this browser.");
            return;
        }

        const recognition = new SpeechRecognition();
        recognition.lang = "en-US";
        recognition.continuous = false;
        recognition.interimResults = false;

        recognition.onstart = () => setListening(true);
        recognition.onend = () => setListening(false);
        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            setInput((prev) => (prev ? prev + " " + transcript : transcript));
        };

        recognitionRef.current = recognition;
        recognition.start();
    };

    const toggleListening = () => {
        if (listening && recognitionRef.current) {
            recognitionRef.current.stop();
            setListening(false);
        } else {
            initRecognition();
        }
    };

    return (
        <div className="bg-white border-top p-2" style={{ flexShrink: 0 }}>
            {/* 🌀 Scrolling Recommendation Bar */}
            <div
                className="scrolling-banner mb-2"
                style={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    width: "100%", // full width of chat section only
                    maxWidth: "100%",
                    background: "#f8f9fa",
                    borderRadius: "6px",
                    padding: "4px 0",
                }}
            >        <div className="scrolling-text"
                style={{
                    width: "100%", // full width of chat section only
                    maxWidth: "100%",
                }}
            >
                    {recommendations?.length ? recommendations.map((tip, index) => (
                        <Text
                            key={index}
                            type="secondary"
                            style={{ marginRight: "1.5rem", fontSize: "13px" }}
                        >
                            {tip.title}
                        </Text>
                    )) : []}
                </div>
            </div>

            {/* Input Section */}
            <div className="input-group">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Ask me anything about your data..."
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyPress={(e) => e.key === "Enter" && !e.shiftKey && sendMessage()}
                    disabled={loading}
                    style={{ fontSize: "0.95rem" }}
                />

                <button
                    className={`btn ${listening ? "btn-danger" : "btn-outline-secondary"}`}
                    type="button"
                    onClick={toggleListening}
                    disabled={loading}
                >
                    <Mic size={18} />
                </button>

                <button
                    className="btn btn-success"
                    onClick={sendMessage}
                    disabled={loading || !input.trim()}
                >
                    {loading ? (
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    ) : (
                        <Send size={18} />
                    )}
                </button>
            </div>
        </div>
    );
}

export default ChatInput;
